import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  Popover,
  CardHeader,
  CardActions,
  Divider,
  Button,
  colors
} from '@material-ui/core';
import { Page } from 'components'; 
import { Header, Results } from './components';
import AuthFetch from 'utils/fetch'
import { urls } from 'utils/url'
import { ConversationPlaceholder } from 'views/Chat/components';



const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

const ToDoList = () => {
  const classes = useStyles();
  const [todo, setTodo] = useState([]);

  
  useEffect(() => {
    AuthFetch(urls.allTodo.path, {}, urls.allTodo.method).then((rv)=>{
      let  data = rv.Data.todo.sort(function(a,b){
        return Date.parse(a.expireAt) - Date.parse(b.expireAt);
         });
      setTodo(data);
    })
  }, [0]);
  return (
    <Page
      className={classes.root}
      title="待办事项"
    >
      <Header />
      
      <Results
        className={classes.results}
        todo={todo}
      />
      
    </Page>
  );
};



export default ToDoList;
